import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <div className="max-w-4xl mx-auto px-4 py-10 lg:py-16">
        {/* Header */}
        <header className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            Terms &amp; Conditions – TAMILSANDHAI RETAILERS
          </h1>
          <p className="mt-4 text-sm md:text-base text-gray-600 leading-relaxed">
            This document is an electronic record under the Information Technology Act, 2000, and
            applicable rules. It does not require any physical or digital signature. By accessing or
            using{" "}
            <a
              href="https://tamilsandhai.in/"
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 hover:underline"
            >
              https://tamilsandhai.in/
            </a>{" "}
            (&quot;Website&quot;), you acknowledge that you have read, understood, and agree to be
            bound by these Terms &amp; Conditions.
          </p>
          <p className="mt-3 text-sm md:text-base text-gray-600 leading-relaxed">
            These Terms constitute a legally binding agreement between TAMILSANDHAI RETAILERS, located at
            H25, OLD ASTC HUDCO, THALLY ROAD, HOSUR, TAMIL NADU – 635109, and the users of this
            Website.
          </p>
        </header>

        <div className="space-y-8 text-sm md:text-base leading-relaxed">
          {/* Overview */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">Overview</h2>
            <p>
              This Website is operated by TAMILSANDHAI RETAILERS. Throughout the site, the terms “we”,
              “us”, and “our” refer to TAMILSANDHAI RETAILERS. We provide this Website, including all
              information, tools, and services, conditioned upon your acceptance of these Terms &amp;
              Conditions.
            </p>
            <p className="mt-2">
              By visiting our Website or purchasing from us, you engage in our “Service” and agree
              to comply with all terms, policies, and notices stated here. These Terms apply to all
              users, including browsers, customers, vendors, merchants, and contributors of content.
            </p>
            <p className="mt-2">
              Accessing any part of the Website constitutes acceptance of these Terms. If you do not
              accept them, you must discontinue use immediately.
            </p>
            <p className="mt-2">
              Any new features added to the Website shall also be subject to the current Terms. We
              reserve the right to modify or update these Terms at any time, and the updated version
              will be posted on this page. Continued use of the Website after changes indicates
              acceptance of those modifications.
            </p>
          </section>

          {/* Definitions */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Definitions
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>
                <span className="font-semibold">“Company” / “We” / “Us” / “Our”</span> – TAMILSANDHAI
                RETAILERS.
              </li>
              <li>
                <span className="font-semibold">“User” / “You” / “Your”</span> – Any individual or
                entity accessing or using the Website.
              </li>
              <li>
                <span className="font-semibold">“Products/Services”</span> – Goods, digital items,
                subscriptions, or services offered on our Website.
              </li>
            </ul>
          </section>

          {/* Use of Website */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Use of Website
            </h2>
            <p>By using the Website, you confirm that:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>You are at least 18 years of age.</li>
              <li>The information you provide is accurate and complete.</li>
              <li>
                You will not misuse the Website for fraudulent, harmful, or unlawful activities.
              </li>
            </ul>
            <p className="mt-2">
              We may restrict or terminate Website access at any time if misuse is detected.
            </p>
          </section>

          {/* Online Store Terms */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Online Store Terms
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>You are legally eligible to enter into a binding contract.</li>
              <li>
                You will not violate any local, national, or international laws while using our
                Services.
              </li>
              <li>You will not transmit viruses, harmful code, or malicious content.</li>
            </ul>
            <p className="mt-2">
              Any breach of these Terms may result in immediate termination of your access.
            </p>
          </section>

          {/* General Conditions */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              General Conditions
            </h2>
            <p>
              We reserve the right to refuse service to anyone at any time. You understand that your
              content (excluding payment details) may be transferred unencrypted over various
              networks for technical processing. Payment data is always encrypted during
              transmission.
            </p>
            <p className="mt-2">
              You agree not to reproduce, duplicate, copy, or resell any part of the Website or
              Service without our written permission.
            </p>
          </section>

          {/* Accuracy, Completeness & Timeliness of Information */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Accuracy, Completeness &amp; Timeliness of Information
            </h2>
            <p>
              We do not guarantee that information available on this Website is accurate, complete,
              or current. Content is provided for general information only and should not be relied
              upon as the sole basis for decision-making.
            </p>
            <p className="mt-2">
              Historical or outdated information may appear on the Website. We reserve the right to
              modify Website content at any time but are not obligated to update information.
            </p>
          </section>

          {/* Products & Services */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Products &amp; Services
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>All product details, pricing, and availability are shown on the Website.</li>
              <li>Prices may change without prior notice.</li>
              <li>Product descriptions may be modified at any time.</li>
              <li>We reserve the right to limit or discontinue products.</li>
              <li>We do not guarantee accurate color representation on your device.</li>
            </ul>
          </section>

          {/* Order Acceptance & Payment */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Order Acceptance &amp; Payment
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Placing an order does not guarantee acceptance.</li>
              <li>Orders are confirmed only after successful payment.</li>
              <li>Payments are processed via secure third-party gateways.</li>
              <li>We are not responsible for payment delays or failures.</li>
            </ul>
          </section>

          {/* Accuracy of Billing & Account Information */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Accuracy of Billing &amp; Account Information
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>You must provide accurate billing and shipping details.</li>
              <li>You must keep account information updated.</li>
              <li>
                We may cancel or limit orders using the same payment method or address.
              </li>
            </ul>
            <p className="mt-2">
              If an order is modified or cancelled, we will attempt to notify you.
            </p>
          </section>

          {/* Shipping & Delivery */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Shipping &amp; Delivery
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Delivery timelines are estimates and may vary.</li>
              <li>We are not responsible for courier delays or unforeseen issues.</li>
              <li>Incorrect address details may result in delivery failures.</li>
            </ul>
          </section>

          {/* Return, Refund & Cancellation */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Return, Refund &amp; Cancellation
            </h2>
            <p>
              All returns, refunds, and cancellations are governed by our Return &amp; Refund Policy
              available on the Website. Users must review this policy before making a purchase.
            </p>
          </section>

          {/* Intellectual Property */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Intellectual Property
            </h2>
            <p>
              All Website content—text, graphics, logos, images, videos, and software—belongs to
              TAMILSANDHAI RETAILERS. You may not copy, reproduce, modify, or distribute any content
              without written consent.
            </p>
          </section>

          {/* User Conduct */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              User Conduct
            </h2>
            <p>You agree NOT to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Use the Website for unlawful or harmful purposes.</li>
              <li>Attempt unauthorized access or security breaches.</li>
              <li>Upload viruses, malicious code, or inappropriate content.</li>
            </ul>
          </section>

          {/* Limitation of Liability */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Limitation of Liability
            </h2>
            <p>We are not liable for:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Indirect, incidental, or consequential damages.</li>
              <li>Service interruptions caused by external events.</li>
              <li>Losses resulting from third-party providers.</li>
            </ul>
          </section>

          {/* Indemnification */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Indemnification
            </h2>
            <p>
              You agree to indemnify and hold harmless TAMILSANDHAI RETAILERS from claims, losses, or
              damages arising from:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Misuse of the Website</li>
              <li>Violation of these Terms</li>
              <li>Breach of applicable laws</li>
            </ul>
          </section>

          {/* Third-Party Links */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Third-Party Links
            </h2>
            <p>
              Our Website may contain links to third-party sites. We are not responsible for their
              content, accuracy, or practices. Accessing such sites is at your own risk.
            </p>
          </section>

          {/* Privacy */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">Privacy</h2>
            <p>
              Your use of the Website is governed by our Privacy Policy, which outlines how we
              collect, use, and secure your personal data.
            </p>
          </section>

          {/* Optional Tools */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Optional Tools
            </h2>
            <p>
              We may offer access to third-party tools without monitoring or control. These tools
              are provided “as is” without warranties. Your use of optional tools is at your sole
              discretion.
            </p>
          </section>

          {/* Modifications to Service & Prices */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Modifications to Service &amp; Prices
            </h2>
            <p>
              We may modify or discontinue the Website, Service, or pricing at any time without
              notice. We will not be liable for such modifications.
            </p>
          </section>

          {/* Governing Law */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Governing Law
            </h2>
            <p>
              These Terms are governed by the laws of India. Any disputes shall be subject to the
              jurisdiction of courts in Tamil Nadu, India.
            </p>
          </section>

          {/* Contact Information */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
              Contact Information
            </h2>
            <p className="whitespace-pre-line">
              TAMILSANDHAI RETAILERS{"\n"}
              H25, OLD ASTC HUDCO,{"\n"}
              THALLY ROAD, HOSUR,{"\n"}
              TAMIL NADU – 635109
            </p>
            <p className="mt-2">
              Email:{" "}
              <a
                href="mailto:info@tamilsandhai.in"
                className="text-blue-600 hover:underline"
              >
                info@tamilsandhai.in
              </a>
              <br />
              Website:{" "}
              <a
                href="https://tamilsandhai.in/"
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 hover:underline"
              >
                https://tamilsandhai.in/
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
